export default {
    INS_SUPER_ADMIN: 'admin',
    BRANCH_ADMIN: 'level-three',
    LEVEL_ONE_ADMIN: 'level-one',
    LEVEL_TWO_ADMIN: 'level-two',
};
